import { memo } from 'react'
import { Flex, Text } from '@chakra-ui/react'

import { useFilterGroupForDates } from '../../contexts/Provider'

const SelectedFilterDateValue = () => {
  const { filterDate } = useFilterGroupForDates()

  if (!filterDate?.label) return null

  return (
    <Flex direction="column" align="flex-start" pt={4} gap={1}>
      <Text fontSize="md">Está filtrando por: </Text>
      <Text textAlign="left" color="primary" fontSize="md">
        {filterDate?.label}
      </Text>
    </Flex>
  )
}

export default memo(SelectedFilterDateValue)
